<template>
    <div class="secret-wrapper">
        <div class="subscription-modal">
            <template v-if="state === 'subscribeForm'">
                <h1 class="sec-title">{{trans('EMAIL NEWSLETTER SUBSCRIPTION')}}</h1>
                <h3 class="subscription-modal__title">{{trans('Subscribe to get exclusive access to a closed drop')}}</h3>
                <h4 class="subscription-modal__subtitle subscription-modal-uppercase">{{trans('with extremely accessible prices, starting from $40')}}</h4>
                <form class="subscription-modal__form">
                    <div class="input-wrapper ">
                        <input
                            v-model="email"
                            type="text"
                            name="email"
                            style="height: 42px"
                            placeholder="EMAIL"
                            class="input-element input-wrapper__element-inp input-wrapper__element-inp-js">
                    </div>
                    <div v-if="genderSpecify" class="input-wrapper">
                        <div class="select-size">
                            <div class="select-size__header input-wrapper__element-inp" @click="show_gender = !show_gender"
                                 :class="show_gender ? 'select-active':''">
                                <p class="select-size__header-title sex-select__title"
                                   v-if="gender">
                                    {{ gender === 1 ? trans('Male gender') : trans('Female gender') }}</p>
                                <p class="select-size__header-title sex-select__title placeholder"
                                   v-if="!gender">{{ trans("Gender") }}</p>
                                <img class="select-size__header-img" src="https://batnorton.com/img/svg/select-ar.svg"
                                     alt="">
                            </div>
                            <div class="select-size__body">
                                <ul class="list select-size__list" v-show="show_gender"
                                    :class="show_gender ? 'select-size__body_displayed':''">
                                    <li @click="setGender(1)" class="list__element select-size__element">
                                        <span class="select-size__element-value">{{trans('Male gender')}}</span>
                                        <span class="select-size__element-value"></span>
                                    </li>
                                    <li @click="setGender(2)" class="list__element select-size__element">
                                        <span class="select-size__element-value">{{trans('Female gender')}}</span>
                                        <span class="select-size__element-value"></span>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="checkbox">
                        <div style="position: relative;">
                            <input v-model="checkbox"
                                   :checked="checkbox"
                                   class="checkbox__input" type="checkbox" name="subscribe_input" id="subscribe_input">
                            <label @click="checkbox = !checkbox" class="checkbox__label" id="subscribe"></label>
                        </div>
                        <span class="checkbox__title" @click="checkbox = !checkbox">{{trans('I give my consent to receive information about news and special offers and confirm that I have read and agree to the')}} <a
                            href="/privacy-policy">{{trans('Privacy Policy')}}</a></span>
                    </div>
                    <div :class="['subscr-button-wrap', { 'already-subscribed': !buttonDisabled }]">
                        <button @click.prevent="subscribe"
                                :disabled="isSubscribed || buttonDisabled"
                                class="btn btnV2 subscription-modal__button-js">
                            {{ isSubscribed ? trans("You have already subscribed") : trans("Subscribe") }}</button>
                    </div>
                </form>
            </template>
            <template v-if="state === 'loginForm'">
                <h1 class="sec-title text-center">SECRET DROP</h1>
                <h3 class="subscription-modal__title text-center">{{trans('TO OPEN THE DROP, ENTER THE PASSWORD YOU RECEIVED IN THE EMAIL NEWSLETTER')}}</h3>
                <form class="subscription-modal__form" style="align-items: center;margin-bottom: 10px">
                    <div class="input-wrapper" style="margin-bottom: 15px">
                        <input
                            v-model="password"
                            type="password"
                            name="password"
                            style="height: 42px"
                            :placeholder="trans('Password')"
                            class="input-element input-wrapper__element-inp input-wrapper__element-inp-js">
                    </div>

                    <button @click.prevent="login"
                            style="max-height: 42px;"
                            class="btn btnV2 subscription-modal__button-js">{{trans('OPEN')}}</button>
                </form>
                <h3 @click="() => state = 'subscribeForm'" class="subscription-modal__title text-center btn">{{trans("I DON'T HAVE A PASSWORD.")}}</h3>
            </template>
            <div v-if="state === 'thankMessage'">
                <h1 class="sec-title">{{trans('EMAIL NEWSLETTER SUBSCRIPTION')}}</h1>
                <h1 class="sec-title">{{trans('THANK YOU, YOU’RE SUBSCRIBED')}}</h1>
                <div v-if="false" class="tg-invitation-wrap">
                    <div class="tg-link-wrap">
                        <a href="https://t.me/+WC1PXvkkdkEzNzUy" target="_blank" class="tg-icon">
                            <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M33.818 7.97089L29.1467 29.8394C28.7983 31.3796 27.9041 31.7264 26.6122 31.0311L19.6054 25.8635L16.1751 29.1426C15.8283 29.491 15.4799 29.8394 14.6844 29.8394L15.2316 22.6321L28.3019 10.7551C28.8476 10.2079 28.1524 10.009 27.4571 10.4576L11.2064 20.6943L4.19794 18.5575C2.65781 18.0611 2.65781 17.0159 4.54635 16.3221L31.7799 5.73548C33.1211 5.33773 34.2651 6.03456 33.818 7.97089Z" fill="white"/>
                            </svg>
                        </a>
                        <a href="https://t.me/+WC1PXvkkdkEzNzUy" target="_blank" class="tg-invitation">Вступай в закрытый Telegram-канал<br /><strong>Bat Norton Private Drop</strong>.</a>
                    </div>
                    <div class="tg-benefits">
                        <p>Только там — эксклюзивные кадры, инсайды и процессы создания дропа. Для тех, кто хочет видеть больше, чем доступно всем.</p>
                    </div>
                </div>
                <div v-if="false" class="button-wrap">
                    <a href="https://t.me/+WC1PXvkkdkEzNzUy" target="_blank" class="btn btnV2 subscription-modal__button-js">
                        {{ trans("Join") }}
                    </a>
                </div>
            </div>
            <h1 v-if="state === 'errorMessage'" class="sec-title" style="line-height: 40px;">Подписка не удалась. <br>
                Возможно, вы ранее отписались от наших писем.
                Попробуйте использовать другую электронную почту для оформления подписки.</h1>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',
    data() {
        return{
            email: '',
            password: '',
            show_gender: false,
            checkbox: true,
            gender: null,
            state: 'loginForm',
            buttonDisabled: false,
            genderSpecify: false,
            lcKey: ''
        }
    },
    mounted() {
        if(this.$store.state.settings.secret.stage === 1) {
            this.state = 'subscribeForm'
            this.lcKey = this.$store.state.settings.secret.key + '-air'
        } else if (this.$store.state.settings.secret.stage === 2) {
            this.state = 'loginForm'
            this.lcKey = this.$store.state.settings.secret.key + '-air'
        }
    },
    methods: {
        setGender(male) {
            this.gender = male
            this.show_gender = false
        },
        validateEmail() {
            this.email = this.email.trim()
            const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
            return emailRegex.test(this.email)
        },
        async subscribe() {
            if (this.genderSpecify && !this.gender) {
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Specify the gender'),
                    type: 'error',
                });
            }
            if (!this.checkbox) {
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('You must agree to the terms and conditions'),
                    type: 'error',
                });
            }
            if(this.email.length === 0){
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Fill in the email'),
                    type: 'error',
                });
            }else if(!this.validateEmail()){
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Incorrect email address'),
                    type: 'error',
                });
            }else {
                this.buttonDisabled = true;
                await axios.get('/api/v1/set-subscribe', {
                    params: this.setParam({
                        email:  this.email,
                        guest:  this.$store.state.settings.guest.id,
                        gender: this.gender,
                        type: 2
                    })
                })
                .then(data => {
                    this.buttonDisabled = false;
                    if(data.data.status === 'success'){
                        this.state = 'thankMessage'
                        localStorage.setItem(this.lcKey, JSON.stringify({
                            'time': new Date().setFullYear(9999).toFixed(),
                            'subscribed': true
                        }))
                        if (import.meta.env.MODE === 'production' && this.$store.state.settings.site_id == 1) {
                            _tmr.push({ type: 'reachGoal', id: 3290316, goal: 'subscription'})
                            ym(80128144,'reachGoal','subscription1')
                        }
                    }
                    if(data.data.status === 'warning'){
                        this.state = 'errorMessage'
                    }
                    if(data.data.status === 'error'){
                        this.$notify({
                            title: this.trans('Error'),
                            text: data.data.text,
                            type: 'error',
                        });
                    }
                })
            }
        },
        async login() {
            await axios.post('/secret-submit', {
                params: this.setParam({
                    password: this.password,
                })
            }).then(data => {
                if(data.data.status == 'success'){
                    let params = new URLSearchParams(document.location.search);
                    let value = params.get('redirect')
                    if (value) {
                        location.href = '/' + value
                    } else {
                        location.href = data.data.redirect
                    }
                }
                if(data.data.status == 'error'){
                    this.$notify({
                        title: this.trans('Error'),
                        text: data.data.text,
                        type: 'error',
                    });
                }
            });
        }
    },
    computed: {
        isSubscribed() {
            const data = JSON.parse(localStorage.getItem(this.lcKey))
            if (!data) {
                return false
            }
            return Boolean(data.subscribed)
        }
    }
};
</script>

<style scoped lang="scss">
.secret-wrapper h1.sec-title:first-child {
    margin-bottom: 20px;
}
.secret-wrapper h4.subscription-modal__title {
    margin-top: 5px;
}
.secret-wrapper .subscription-modal {
    background-color: rgba(2, 3, 3, 0.5);
    max-width: 620px;
}
.subscription-modal-uppercase {
    text-transform: uppercase;
}
.secret-wrapper .subscription-modal__button-js {
    background: #ffffff;
    border: none;
    color: #000000;
    border: 1px solid #000000;
    padding: 12px 20px;
    &:hover {
        background: #ffffff;
        color: #000000;
        border: 1px solid #000000;
    }
    &:disabled {
        background: #000000;
        color: #ffffff;
        border: 1px solid #000000;
    }
}
.tg-link-wrap {
    display: flex;
    width: 100%;
    align-items: center;
}
.tg-link-wrap .tg-icon {
    flex: 0 0 auto;
    padding: 10px;
    white-space: nowrap;
}
.tg-link-wrap .tg-invitation {
    flex: 1 1 auto;
    padding: 10px;
    color: #ffffff;
    text-transform: uppercase;
    font-size: 18px;
    line-height: 105%;
}
.tg-link-wrap span strong {
    font-weight: 600;
}
.tg-benefits {
    margin-top: 10px;
    color: #ffffff;
    font-size: 16px;
    line-height: 100%;
}
.button-wrap {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top:20px;
}
.subscr-button-wrap {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}
.already-subscribed {
    justify-content: center;
}
</style>
